import React, {Component} from "react";
import {Link} from "react-router";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import Help from "../img/help.png";
import "./Connections.css";
import {currentSiteName} from "../../../service/SiteService";

class GettingStarted extends Component {
    constructor() {
        super();
        this.state = {teamName: ''};

        this.onChangeTeamName = this.onChangeTeamName.bind(this)
    }

    onChangeTeamName(e) {
        this.setState({teamName: e.target.value});
    }

    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Getting Started</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>This guide will help you get up and running quickly.</p>

                                <blockquote>
                                    <p>For information about what {currentSiteName} <em>is</em>, check out our <Link to="/docs/bot/faq">Frequently
                                        Asked Questions</Link> section.</p>
                                </blockquote>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h3>Before you begin</h3>
                                <p>
                                    You need to have a <Link href="https://www.slack.com">Slack</Link> account. Already got one? On to step 1...
                                </p>

                                <h3>Setting up</h3>

                                {/* Slack */}
                                <h4>Step 1: Add bot to your Slack team</h4>
                                <p>
                                    In order to talk to {currentSiteName}, you need to add a 'bot user' to your Slack
                                    team. This is quick and easy - just follow our simple <Link to="/docs/bot/connections">Connections</Link> guide.
                                </p>

                                {/* Build systems */}
                                <h4>Step 2: Link to your build system</h4>
                                <p>
                                    You can use {currentSiteName} with your existing Rundeck or Jenkins instances.
                                </p>

                                <h5>Link to Jenkins</h5>
                                <p>
                                    If you're using Jenkins, check out the <Link to="/docs/bot/build-systems">Build systems</Link> section.
                                </p>

                                <h5>Link to Rundeck</h5>
                                <p>
                                    If you're using Rundeck, check out the <Link to="/docs/bot/build-systems">Build systems</Link> section.
                                </p>

                                {/* Actions */}
                                <h4>Step 3: Configure actions</h4>
                                <p>
                                    It's time to set up the actions {currentSiteName} can perform for you. See the <Link to="/docs/bot/actions">Actions</Link> guide for
                                    details.
                                </p>

                                <h3>Using {currentSiteName}</h3>
                                {/* Test */}
                                <h4>Step 4: Time to test</h4>
                                <p>
                                    Once you've added some actions, open up your Slack team and join one of the
                                    channels you added in the <Link to="/bot/connections">Connections</Link> screen.
                                </p>
                                <p>
                                    Don't forget to invite your bot to the channel if it is not already a member.
                                    Slack doesn't let bots join channels uninvited.
                                </p>
                                <p>
                                    To find out what you can do, try typing:
                                    <pre className="m-t-sm">
                                        @cloudMocks help
                                    </pre>
                                    <blockquote>
                                        <strong>Note:</strong> replace <i>@cloudMocks</i> with the name of your bot
                                        in your Slack team.
                                    </blockquote>

                                    <p>
                                        You'll see something like this:
                                    </p>
                                    <img src={Help} style={{width: 395}} className="step" alt="Bot help response"/>
                                </p>

                                {/* Explore */}
                                <h4>Step 5: Explore</h4>
                                <p>
                                    See what you can ask {currentSiteName} to do from the <Link to="/docs/bot/actions">Actions</Link> section.
                                </p>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default GettingStarted;



// WEBPACK FOOTER //
// ./src/modules/views/docs/bot/GettingStarted.js